import script from "./BankingDetailsList.vue?vue&type=script&setup=true&lang=js"
export * from "./BankingDetailsList.vue?vue&type=script&setup=true&lang=js"

import "./BankingDetailsList.vue?vue&type=style&index=0&id=54cf59cb&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54cf59cb"]])

export default __exports__